import React, { useEffect, useState } from "react";
import { Tab, Nav } from "react-bootstrap";
import { useLazyQuery, useQuery } from "@apollo/react-hooks";
import { GET_ALL_POST } from "../../query/GetPosts";
import { hasuraClient } from "../../apolloClient";
import PostTab from "../Posts/PostTab";
import EventTab from "../Event/EventTab";
import { GET_ALL_EVENTS } from "../../query/GetEvents";
import moment from "moment";
import Gallery from "./Gallery";
import { GET_IMAGE_EVENT } from "../../query/Gallery";
import DealList from "../Deals/DealList";
import { GET_DEALS } from "../../query/getDeals";
import Review from "./Review";
import { GET_REVIEW_COUNT } from "../../query/getReviewCount";
import { GET_CLUB_REVIEW_COUNT } from "../../query/getClubReviewCount";
import { useParams, useHistory } from "react-router-dom";
import { VIEW_ROLE } from "../../query/ViewRole";
import { VIEW_PROFILE } from "../../query/ViewProfile";

const BusinessTab = () => {
  const [eventKey, setEventKey] = useState("post");
  const [allEventImagesData, setAllEventImagesData] = useState([]);

  const { data: userRole } = useQuery(VIEW_ROLE, {
    variables: {
      userId: localStorage.getItem("user_id"),
    },
    fetchPolicy: "cache-and-network",
    client: hasuraClient,
  });
  const { data: userData } = useQuery(VIEW_PROFILE, {
    client: hasuraClient,
  });

  const { data: reviewCount } = useQuery(GET_REVIEW_COUNT, {
    client: hasuraClient,
    variables: {
      business_profile_id: userData?.users[0]?.business_profile?.id,
    },
  });

  const { data: clubReviewCount } = useQuery(GET_CLUB_REVIEW_COUNT, {
    client: hasuraClient,
    variables: {
      club_profile_id: userData?.users[0]?.club_profile?.id,
    },
  });
  const [getDeals, { data: deals }] = useLazyQuery(GET_DEALS, {
    fetchPolicy: "cache-and-network",
    client: hasuraClient,
  });

  const [
    searchQuery,
    { data, refetch, loading: publishedPostLoading, error: publishedPostError },
  ] = useLazyQuery(GET_ALL_POST, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
    client: hasuraClient,
    variables: {
      profile_id: localStorage.getItem("profile_id"),
    },
  });

  const params = useParams();
  const history = useHistory();

  useEffect(() => {
    if (params && params.id) {
      setEventKey(params.id);
    } else {
      setEventKey("post");
    }
  }, [params]);

  useEffect(() => {
    searchQuery({
      variables: {
        status: ["draft", "published", "scheduled"],
      },
    });
  }, []);

  useEffect(() => {
    getDeals({
      variables: {
        searchText: "%%",
        id: localStorage.getItem("profile_id"),
        type: null,
        current_date_time: moment().format(),
      },
    });
  }, []);

  const [date, setDate] = useState("");

  const [
    getAllEvents,
    {
      data: eventData,
      loading: getAllEventsLoading,
      error: getAllEventsError,
      refetch: refetchEvents,
    },
  ] = useLazyQuery(GET_ALL_EVENTS, {
    client: hasuraClient,
    variables: {
      profile_id: localStorage.getItem("profile_id"),
      currentDateTime: date,
    },
  });

  const [
    getImageGallery,
    { data: allEventImages, loading: allEventImagesLoading },
  ] = useLazyQuery(GET_IMAGE_EVENT, {
    fetchPolicy: "cache-and-network",
    client: hasuraClient,
  });

  useEffect(() => {
    if (allEventImages?.business_council_image_gallery_view?.length) {
      let arr = [...allEventImagesData];
      for (
        let i = 0;
        i < allEventImages?.business_council_image_gallery_view?.length;
        i++
      ) {
        arr.push(allEventImages?.business_council_image_gallery_view[i]);
      }
      setAllEventImagesData(arr);
    }
  }, [allEventImages]);

  useEffect(() => {
    getImageGallery({
      variables: {
        limit: 6,
        offset: 0,
      },
    });
    setDate(moment().toISOString());
    getAllEvents();
  }, []);

  return userRole?.users[0].role === "business" ? (
    <div className="counciltab">
      <div className="council-tab-inner">
        <Tab.Container id="left-tabs-example" defaultActiveKey="Post">
          <Nav variant="pills" className="flex-column">
            <Nav.Item>
              <Nav.Link
                eventKey="Post"
                active={eventKey === "post"}
                onClick={() => (
                  setEventKey("post"), history.push("/business-profile/post")
                )}
              >
                <span className="tab-name">Post</span>
                <span className="count">
                  {data?.posts_total?.aggregate?.count}
                </span>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                eventKey="Events"
                active={eventKey === "events"}
                onClick={() =>
                  (
                    setEventKey("events"),
                    history.push("/business-profile/events")
                  )
                }
              >
                <span className="tab-name">Events</span>
                <span className="count">
                  {eventData?.all_count?.aggregate?.count}
                </span>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                eventKey="Gallery"
                active={eventKey === "gallery"}
                onClick={() =>
                  (
                    setEventKey("gallery"),
                    history.push("/business-profile/gallery")
                  )
                }
              >
                <span className="tab-name">Gallery</span>
                <span className="count">
                  {
                    allEventImages
                      ?.business_council_image_gallery_view_aggregate?.aggregate
                      ?.count
                  }
                </span>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                eventKey="Deals"
                active={eventKey === "deals"}
                onClick={() =>
                 (
                    setEventKey("deals"),
                    history.push("/business-profile/deals")
                  )
                }
              >
                <span className="tab-name">Deals</span>
                <span className="count">
                  {
                    deals?.deals?.filter(
                      (data) =>
                        moment([
                          parseInt(
                            moment(data.expire_date_time).format("YYYY")
                          ),
                          parseInt(moment(data.expire_date_time).format("MM")) -
                            1,
                          parseInt(moment(data.expire_date_time).format("DD")),
                        ]).diff(
                          moment([
                            parseInt(moment().format("YYYY")),
                            parseInt(moment().format("MM")) - 1,
                            parseInt(moment().format("DD")),
                          ]),
                          "days"
                        ) >= 0
                    ).length
                  }
                </span>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                eventKey="Review"
                active={eventKey === "review"}
                onClick={() =>
                  (
                    setEventKey("review"),
                    history.push("/business-profile/review")
                  )
                }
              >
                <span className="tab-name">Review</span>
                <span className="count">
                  {userRole?.users[0].role === "business"
                    ? reviewCount?.business_reviews_aggregate?.aggregate?.count
                    : clubReviewCount?.club_reviews_aggregate?.aggregate?.count}
                </span>
              </Nav.Link>
            </Nav.Item>
          </Nav>

          <Tab.Content>
            <Tab.Pane eventKey="Post" active={eventKey === "post"}>
              <div className="post-block" style={{ padding: 0 }}>
                <div className="tab-content" style={{ paddingTop: 0 }}>
                  <PostTab
                    data={data}
                    refetch={refetch}
                    loading={publishedPostLoading}
                    error={publishedPostError}
                    page="profile"
                    noEditDelete
                  />
                </div>
              </div>
            </Tab.Pane>
            <Tab.Pane eventKey="Events" active={eventKey === "events"}>
              <div className="post-block" style={{ padding: 0 }}>
                <div className="tab-content" style={{ paddingTop: 0 }}>
                  <EventTab
                    noEditDelete
                    data={eventData ? eventData?.all_event : null}
                    refetch={refetchEvents}
                    loading={getAllEventsLoading}
                    error={getAllEventsError}
                  />
                </div>
              </div>
            </Tab.Pane>
            <Tab.Pane eventKey="Gallery" active={eventKey === "gallery"}>
              <Gallery
                count={
                  allEventImages?.business_council_image_gallery_view_aggregate
                    ?.aggregate?.count
                }
                data={allEventImagesData}
                searchQuery={getImageGallery}
                loading={allEventImagesLoading}
              />
            </Tab.Pane>
            <Tab.Pane eventKey="Deals" active={eventKey === "deals"}>
              <DealList deals={deals?.deals} notThreeDots={true} />
            </Tab.Pane>
            <Tab.Pane eventKey="Review" active={eventKey === "review"}>
              <Review />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </div>
  ) : (
    <div className="counciltab">
      <div className="council-tab-inner">
        <Tab.Container id="left-tabs-example" defaultActiveKey="Post">
          <Nav variant="pills" className="flex-column">
            <Nav.Item>
              <Nav.Link
                eventKey="Post"
                active={eventKey === "post"}
                onClick={() => (
                  setEventKey("post"), history.push("/club-profile/post")
                )}
              >
                <span className="tab-name">Post</span>
                <span className="count">
                  {data?.posts_total?.aggregate?.count}
                </span>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                eventKey="Events"
                active={eventKey === "events"}
                onClick={() => (
                  setEventKey("events"), history.push("/club-profile/events")
                )}
              >
                <span className="tab-name">Events</span>
                <span className="count">
                  {eventData?.all_count?.aggregate?.count}
                </span>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                eventKey="Gallery"
                active={eventKey === "gallery"}
                onClick={() => (
                  setEventKey("gallery"), history.push("/club-profile/gallery")
                )}
              >
                <span className="tab-name">Gallery</span>
                <span className="count">
                  {
                    allEventImages
                      ?.business_council_image_gallery_view_aggregate?.aggregate
                      ?.count
                  }
                </span>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                eventKey="Deals"
                active={eventKey === "deals"}
                onClick={() => (
                  setEventKey("deals"), history.push("/club-profile/deals")
                )}
              >
                <span className="tab-name">Deals</span>
                <span className="count">
                  {
                    deals?.deals?.filter(
                      (data) =>
                        moment([
                          parseInt(
                            moment(data.expire_date_time).format("YYYY")
                          ),
                          parseInt(moment(data.expire_date_time).format("MM")) -
                            1,
                          parseInt(moment(data.expire_date_time).format("DD")),
                        ]).diff(
                          moment([
                            parseInt(moment().format("YYYY")),
                            parseInt(moment().format("MM")) - 1,
                            parseInt(moment().format("DD")),
                          ]),
                          "days"
                        ) >= 0
                    ).length
                  }
                </span>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                eventKey="Review"
                active={eventKey === "review"}
                onClick={() => (
                  setEventKey("review"), history.push("/club-profile/review")
                )}
              >
                <span className="tab-name">Review</span>
                <span className="count">
                  {userRole?.users[0].role === "business"
                    ? reviewCount?.business_reviews_aggregate?.aggregate?.count
                    : clubReviewCount?.club_reviews_aggregate?.aggregate?.count}
                </span>
              </Nav.Link>
            </Nav.Item>
          </Nav>

          <Tab.Content>
            <Tab.Pane eventKey="Post" active={eventKey === "post"}>
              <div className="post-block" style={{ padding: 0 }}>
                <div className="tab-content" style={{ paddingTop: 0 }}>
                  <PostTab
                    data={data}
                    refetch={refetch}
                    loading={publishedPostLoading}
                    error={publishedPostError}
                    page="profile"
                    noEditDelete
                  />
                </div>
              </div>
            </Tab.Pane>
            <Tab.Pane eventKey="Events" active={eventKey === "events"}>
              <div className="post-block" style={{ padding: 0 }}>
                <div className="tab-content" style={{ paddingTop: 0 }}>
                  <EventTab
                    noEditDelete
                    data={eventData ? eventData?.all_event : null}
                    refetch={refetchEvents}
                    loading={getAllEventsLoading}
                    error={getAllEventsError}
                  />
                </div>
              </div>
            </Tab.Pane>
            <Tab.Pane eventKey="Gallery" active={eventKey === "gallery"}>
              <Gallery
                count={
                  allEventImages?.business_council_image_gallery_view_aggregate
                    ?.aggregate?.count
                }
                data={allEventImagesData}
                searchQuery={getImageGallery}
                loading={allEventImagesLoading}
              />
            </Tab.Pane>
            <Tab.Pane eventKey="Deals" active={eventKey === "deals"}>
              <DealList deals={deals?.deals} notThreeDots={true} />
            </Tab.Pane>
            <Tab.Pane eventKey="Review" active={eventKey === "review"}>
              <Review />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </div>
  );
};

export default BusinessTab;
